var common = require("../../utiles/common.js")
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");
var metaUtils = require("../../utiles/metaTypeUtils");
var columns = require("./userColumns");

module.exports = {
    register: function () {
        document.createElement('user-task')
        ko.components.register('user-task', {
            viewModel: function (params) {
                var $this = this;
                $this.requestAttrs = ko.observableArray();
                $this.viewData = ko.observable({});
                $this.formData = ko.observable({});
                $this.usertaskFill = ko.observable({});
                $this.activeObject = ko.observable({});
                //取消表单
                $this.cancelformData = {
                    fields: [
                        {
                            display: "原因",
                            type: "textarea",
                            fieldName:"cancelReson",
                        }
                    ],
                }
                $this.renderAttr = function(attr,data){
                    var setter = metaUtils.getAddon(metaUtils.metaType.QNAME_ATTRIBUTE_ADDON_SETTER,attr.addons);
                    return metaUtils.getValue(attr,data,setter)
                };

                
                
                $this.renderList = function(dataTypeQualifyName,id,cols){
                    layUtils.table({
                        elem: "#"+id,
                        height: 600,
                        url:"/auth/dataSearch/queryManageViewData",
                        method:"post",
                        where:{
                            dataTypeQualifyName:dataTypeQualifyName,
                            condition:{owner:common.getStorage().user.subjectId},
                            sort:[
                                {
                                    attributeCode:"createdDate",
                                    type: "DESC"
                                  }
                            ]
                        },
                        page: true,
                        cols: cols,
                        event:{
                            id:'tool(entitlement)',
                            callback:function(item){
                                console.log(item)
                                var trData = item.data;
                                var event = item.event;
                                $this.activeObject(trData);
                                switch(event){
                                    case "detail":
                                        $this.detail(trData);
                                        break;
                                    case "form":
                                        $this.form(trData);
                                        break;
                                    case "cancel":
                                        $this.cancel(trData);
                                        break;
                                }
                            }
                        }
                    });
                }
                $this.form = function(trData){
                    var formIndex;
                    //表单填写
                    var result = metaUtils.buildFormData({
                        qualifyName:trData.formQualifyName,
                        data:trData.formData?JSON.parse(trData.formData):{},
                        formDefine:trData.formDefine,
                        submitText:"提交",
                        callback:function(data){
                            console.log(data);
                            common.fetch("/auth/usertask/pform",{
                                type:"POST",
                                data: JSON.stringify({
                                    taskId:trData.id,
                                    flowInstanceId:trData.flowInstanceId,
                                    formData:data
                                }),
                                success:function(result){
                                    console.log(result)
                                    layUtils.close(formIndex);
                                    $this.renderList(metaUtils.metaType.QNAME_USERTASK,"UserTask",columns.UserTask);
                                }
                            })
                        }
                    });
                    $this.usertaskFill(result.form);
                    formIndex = layUtils.open({
                        type: 1, 
                        area:["600px","600px"],
                        content: $("#usertaskForm"),
                    })
                }
                $this.cancel = function(trData){
                    var cancelIndex;
                    cancelIndex = layUtils.open({
                        type: 1, 
                        area:["600px","400px"],
                        content: $("#usertaskCancel"),
                        form:{
                            formId:"usertaskCancel",
                            data:{},
                            callback:function(data){
                                console.log(data)
                                common.fetch("/auth/usertask/cancel",{
                                    type:"POST",
                                    data: JSON.stringify({
                                        taskId:trData.id,
                                        flowInstanceId:trData.flowInstanceId,
                                        cancel:true,
                                        cancelReson:data.cancelReson
                                    }),
                                    success:function(result){
                                        console.log(result)
                                        layUtils.close(cancelIndex);
                                        $this.renderList(metaUtils.metaType.QNAME_USERTASK,"UserTask",columns.UserTask);
                                    }
                                })
                            }
                        }
                    })
                }
                $this.detail = function(trData){
                    if(trData.entitlementRequestId){
                        common.fetch("/auth/dataSearch/listInheritAttributes",{
                            type:"POST",
                            data: JSON.stringify({qualifyName:metaUtils.metaType.QNAME_ENTITLEMENT_REQUEST}),
                            success:function(result){
                                console.log(result)
                                $this.requestAttrs(result.data)
                            }
                        })
                        common.fetch("/auth/dataSearch/queryManageViewData",{
                            type:"POST",
                            data: JSON.stringify({dataTypeQualifyName:metaUtils.metaType.QNAME_ENTITLEMENT_REQUEST,size:1,condition:{
                                id:trData.entitlementRequestId.id
                            }}),
                            success:function(result){
                                $this.viewData(result.data.result?result.data.result[0]:{})
                                console.log($this.viewData())
                                layUtils.open({
                                    type: 1, 
                                    area:["600px","600px"],
                                    content: $("#fillForm"),
                                    btn:trData.status === "INIT"?["同意","拒绝"]:[],
                                    btn1:function(index, layero){
                                        console.log(index)
                                        $this.approval("APPROVED",trData.id);
                                        layUtils.close(index);
                                    },
                                    btn2:function(index, layero){
                                        console.log(index)
                                        $this.approval("REFUSED",trData.id);
                                        yUtils.close(index);
                                    }
                                })
                            }
                        })
                    }else{
                        if(trData.registerData){
                            common.fetch("/auth/dataSearch/listInheritAttributes",{
                                type:"POST",
                                data: JSON.stringify({qualifyName:metaUtils.metaType.QNAME_IAM_AUTH_REGISTER}),
                                success:function(result){
                                    console.log(result)
                                    $this.requestAttrs(result.data)
                                    $this.formData(trData.registerData);
                                    layUtils.open({
                                        type: 1, 
                                        area:["600px","600px"],
                                        content: $("#regForm"),
                                        btn:trData.status === "INIT"?["同意","拒绝"]:[],
                                        btn1:function(index, layero){
                                            console.log(index)
                                            $this.approval("APPROVED",trData.id);
                                            layUtils.close(index);
                                        },
                                        btn2:function(index, layero){
                                            console.log(index)
                                            $this.approval("REFUSED",trData.id);
                                            layUtils.close(index);
                                        }
                                    })
                                }
                            })
                        }
                    }  
                }
                $this.approval = function(status,taskId){
                    common.fetch("/auth/usertask/flowUserTaskResume",{
                        type:"POST",
                        data: JSON.stringify({status:status,comment:$("#comment").val(),taskId:taskId}),
                        success:function(result){
                            console.log(result)
                            $this.renderList(metaUtils.metaType.QNAME_USERTASK,"UserTask",columns.UserTask);
                        }
                    })
                }
                $this.renderList(metaUtils.metaType.QNAME_USERTASK,"UserTask",columns.UserTask);
            },
            template: require("./UserTask.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/userTask/UserTask.js
// module id = 167
// module chunks = 0